import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authcontext";
import { useFlash } from "../../context/flashcontext";
import { useUserList } from "../../hooks/useUserList";
import UserListView from "./UserListViewModern";

function UserListContainer() {
    const { auth } = useAuth();
    const { showFlash } = useFlash();
    const navigate = useNavigate();
    const userList = useUserList();
    const [userToDelete, setUserToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleViewUser = (id) => {
        navigate(`/users/${id}`);
    };

    const handleInviteUser = async (email, role, setInviteEmail, setInviteRole) => {
        try {
            await userList.inviteUser(email, role);
            showFlash("Uitnodiging verstuurd!.", "success");
            setInviteEmail("");
            setInviteRole("zzper");
        } catch (err) {
            showFlash("Er is iets misgegaan. Probeer het opnieuw.", "error");
        }
    };

    const handleDeleteUser = (id) => {
        setUserToDelete(id);
        setShowDeleteModal(true);
    };

    const confirmDeleteUser = async () => {
        try {
            await userList.deleteUser(userToDelete);
            showFlash("Gebruiker succesvol verwijderd.", "success");
        } catch (err) {
            showFlash("Er is een fout opgetreden bij het verwijderen van de gebruiker.", "error");
        } finally {
            setShowDeleteModal(false);
            setUserToDelete(null);
        }
    };

    const cancelDeleteUser = () => {
        setShowDeleteModal(false);
        setUserToDelete(null);
    };

    return (
        <UserListView
            {...userList}
            auth={auth}
            onViewUser={handleViewUser}
            onInviteUser={handleInviteUser}
            onDeleteUser={handleDeleteUser}
            showDeleteModal={showDeleteModal}
            confirmDeleteUser={confirmDeleteUser}
            cancelDeleteUser={cancelDeleteUser}
        />
    );
}

export default UserListContainer;
